module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (5).1a72f87f.jpg";